<peab-page [options]="headerOptions" (countrySelect)="onCountrySelected($event)">
  <div class="background-container">
    <router-outlet></router-outlet>
  </div>
</peab-page>